import { api } from "@/redux/api";

import { ExportFileInfo } from "./export.schema";

/**
 * Generated exports (PREC-3953). Requesting one is a POST on the owning resource
 * (`contact/export`, `organization/export`); everything after that — progress and the download —
 * lives here, because the file is the same kind of thing whichever tab asked for it.
 */
export const exportApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getExportStatus: builder.query<ExportFileInfo, number>({
			query: (id) => ({ url: `export/${id}` }),
		}),

		downloadExportFile: builder.query<Blob, number>({
			query: (id) => ({
				url: `export/${id}/download`,

				responseHandler: async (response: Response) => {
					if (!response.ok) {
						return { error: response.statusText, status: response.status };
					}

					return response.blob();
				},
			}),
		}),
	}),
});

export const {
	useGetExportStatusQuery,
	useLazyGetExportStatusQuery,
	useLazyDownloadExportFileQuery,
} = exportApi;
